import React from 'react';
import { connect } from 'react-redux';
import { Checkbox } from 'material-ui';
import RateFormatSelection from './rate-format-selection';

class RateFormat extends React.Component {
  constructor() {
    super();
    this.state = {
      downloadType: localStorage ? localStorage.getItem('rateFormat') : 'condensed',
    };
  }
  updateDownloadType = type => {
    if (localStorage) {
      localStorage.setItem('rateFormat', type);
    }
    this.setState({ downloadType: type });
    this.props.updateDownloadType(type);
  }
  render() {
    return (
      <div>
        <div
          style={{ paddingBottom: '12px', borderBottom: '1px solid #e6e9ec', marginBottom: '24px' }}
        >
          <div style={{ fontSize: '24px', fontWeight: 400 }}>Rate Format Settings</div>
        </div>
        <RateFormatSelection
          downloadType={this.state.downloadType}
          updateDownloadType={this.updateDownloadType}
        />
        <div style={{ marginTop: '20px' }}>
          <Checkbox
            defaultChecked={
              localStorage.getItem('doNotShowRateFormatPop') === 'true'
              || localStorage.getItem('doNotShowRateFormatPop') === true
            }
            label="Do not show this preview when I download my rates"
            onCheck={(_, checked) => localStorage.setItem('doNotShowRateFormatPop', checked)}
          />
        </div>
      </div>
    );
  }
}

const actions = {
  updateDownloadType: type => ({ type: '[contracting-download]UPDATE_PROPS', payload: { downloadRateFormat: type } }),
};

export default connect(null, actions)(RateFormat);



// WEBPACK FOOTER //
// ./src/app/components/settings/mySettings/rate-format-setting.jsx